var _defs, _path, _path2, _circle, _path3, _path4, _path5, _path6, _circle2, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUberEats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2,.cls-3{fill:none;stroke:#000000;stroke-linecap:round;stroke-width:8px}.cls-2{stroke-miterlimit:10}.cls-3{stroke-linejoin:round}"))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v192H0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 41.85v31.73c.77 8.11 8.14 14.41 16.88 14.52 8.91.12 16.58-6.25 17.36-14.52V41.85",
    className: "cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.24 88.11V55.2m13.84 32.91V41.85",
    className: "cls-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.53,
    cy: 71.66,
    r: 16.45,
    className: "cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.57 82.97c-3 3.17-7.24 5.14-11.95 5.14-9.09 0-16.45-7.37-16.45-16.45s7.37-16.45 16.45-16.45 16.45 7.37 16.45 16.45h-32.9",
    className: "cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.22 88.11V56.96m11.78 0h0c-1.9 0-3.77.45-5.45 1.32-2.73 1.42-6.33 3.97-6.33 7.51",
    className: "cls-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.04 105.14H20v45.01h30.04",
    className: "cls-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 127.65h30.04m47.61 22.5v-33.08",
    className: "cls-2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.4,
    cy: 133.61,
    r: 16.54,
    className: "cls-2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.62 105.14v40.5c0 2.49 2.02 4.51 4.51 4.51h7.38",
    className: "cls-3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.49 118.52h21.02",
    className: "cls-2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.59 142.08c0 4.33 6.14 7.83 13.71 7.83s13.71-3.51 13.71-7.83-6.14-7.83-13.71-7.83-13.71-3.51-13.71-7.83 6.14-7.83 13.71-7.83 13.71 3.51 13.71 7.83",
    className: "cls-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUberEats);
export default __webpack_public_path__ + "static/media/uberEats.b689e7a49c43d44ae6de79abdb6a9347.svg";
export { ForwardRef as ReactComponent };